import React from "react";
import { Ship, Anchor, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#2C3539] text-[#F9F8F3] pt-16 pb-8 border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Brand Info */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-1.5 bg-[#87412A] rounded-full text-[#F9F8F3]">
                <Ship size={24} strokeWidth={1.5} />
              </div>
              <div>
                <h3 className="text-xl font-bold tracking-wider leading-none">
                  CMJ GLOBAL
                </h3>
                <p className="text-[9px] text-[#F9F8F3]/70 tracking-widest mt-1">
                  MARINE SURVEYORS & CONSULTANTS
                </p>
              </div>
            </div>
            <p className="text-[#F9F8F3]/70 leading-relaxed mb-6 max-w-md">
              A leading independent surveying company offering Pan India
              presence. Driven by quality, focused on delivery, and committed to
              safeguarding your maritime interests.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-lg font-bold mb-6 text-white border-b-2 border-[#87412A] inline-block pb-1">
              Quick Links
            </h4>
            <ul className="space-y-3 text-[#F9F8F3]/80">
              <li>
                <a
                  href="/"
                  className="hover:text-[#87412A] transition-colors flex items-center gap-2"
                >
                  <Anchor size={14} /> Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="hover:text-[#87412A] transition-colors flex items-center gap-2"
                >
                  <Anchor size={14} /> About Us
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="hover:text-[#87412A] transition-colors flex items-center gap-2"
                >
                  <Anchor size={14} /> Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-4">
            <h4 className="text-lg font-bold mb-6 text-white border-b-2 border-[#87412A] inline-block pb-1">
              Reach Us
            </h4>
            <ul className="space-y-4 text-[#F9F8F3]/80">
              <li className="flex items-start gap-3">
                <MapPin className="text-[#87412A] shrink-0 mt-1" size={20} />
                <span>
                  26-A, Mahalaxmi Darshan Appts,
                  <br />
                  Mahalaxmi Temple Compound,
                  <br />
                  B. Desai Road, Cumballa Hill,
                  <br />
                  Mumbai - 400026.
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-[#87412A] shrink-0" size={20} />
                <span>+91 83693 37638</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-[#87412A] shrink-0" size={20} />
                <span>info@cmjglobal.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}

        <div className="border-t border-[#F9F8F3]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#F9F8F3]/50">
          {/* FIX: Replaced text-gray-600 with text-[#F9F8F3]/70 */}
          <p className="text-center text-sm text-[#F9F8F3]/70 sm:text-left">
            © {new Date().getFullYear()},{" "}
            <a
              href="https://100billiontech.com/ownership"
              target="_blank"
              rel="noopener noreferrer"
              /* FIX: Added a base text color to make the links stand out */
              className="text-[#F9F8F3] hover:text-accent transition-colors"
            >
              Copy-rights reserved
            </a>
            . Designed by{" "}
            <a
              href="https://100billiontech.com/"
              target="_blank"
              rel="noopener noreferrer"
              /* FIX: Added a base text color */
              className="text-[#F9F8F3] hover:text-accent transition-colors"
            >
              100billion Tech
            </a>
          </p>
          <div className="flex gap-4">
            {/* <a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
